import * as React from 'react';

import styled from '@emotion/styled';
import Tooltip, { tooltipClasses, TooltipProps } from '@mui/material/Tooltip';
import Zoom from '@mui/material/Zoom';

import '@mui/material/styles';

interface ITooltipProps extends TooltipProps {
  maxWidth?: number;
}

const StyledTooltip = styled(({ className, ...props }: ITooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} placement='top-end' enterTouchDelay={0} />
))(({ maxWidth }: ITooltipProps) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: 'var(--du-color-primary)',
  },
  [`& .${tooltipClasses.tooltip}`]: {
    width: maxWidth || 400,
    maxWidth: maxWidth || 400,
    backgroundColor: 'var(--du-color-primary)',
    color: 'var(--du-color-white)',
    borderRadius: '5px',
    padding: '24px',
    marginBottom: '6px !important',

    '@media (max-width: 768px)': {
      maxWidth: '300px',
      padding: '16px',
    },
  },
}));

const DupontInfoPopover = ({ title, children, ...props }: ITooltipProps) => (
  <StyledTooltip title={title} arrow TransitionComponent={Zoom} {...props}>
    {children}
  </StyledTooltip>
);

export default DupontInfoPopover;
